<template>
  <div class="flex items-center flex-col flex-grow-0" style="width: 200px;height:250px;">
    <vue-qrious
      :size="200"
      :value="qrCodeUrl"
    />
    <template v-if="qrSettings.showBranchName">
      <p class="mb-0 truncate" style="max-width: 200px">{{ qrSettings.branchName }}</p>
    </template>
    <template v-if="qrSettings.showTableName">
      <p class="mb-0 truncate" style="max-width: 200px">{{ tableName  }}</p>
    </template>
  </div>
</template>
<script>
import VueQrious from "vue-qrious";
import { translations } from "@/mixins";
export default {
  name: 'QueueBusterQRCode',
  mixins: [translations],
  components: {
    VueQrious
  },
  props: {
    qrSettings: {
      type: Object,
      required: true,
      default: () => {
        return {
          baseUrl: '',
          branchName: '',
          branchId: null,
          tableName: '',
          showBranchName: false,
          showTableName: false,
          coupon: null,
          orderType: 'eat-in'
        }
      }
    }
  },
  computed: {
    qrCodeUrl() {
      if(this.qrSettings.branchId) {
        let url = `https://${ this.qrSettings.baseUrl }/queuebuster?order-type=${ this.qrSettings.orderType }`;

        if(this.qrSettings.orderType != 'deliver') {
          url = `${ url }&location=${ this.qrSettings.branchId }`
        }

        if(this.qrSettings.orderType == 'eat-in') {
          url = `${ url }&table=${ encodeURIComponent(this.qrSettings.tableName) }`
        }

        if(this.qrSettings.coupon) {
          url = `${ url }&coupon=${ this.qrSettings.coupon }`
        }

        return url;
      }

      return this.qrSettings.baseUrl;
    },
    tableName() {
      return this.qrSettings.tableName ? `${ this.translate('Table:') } ${ this.qrSettings.tableName }` : '';
    }
  }
}
</script>